import { Redirect } from 'react-router-dom';
import { updateTokenForPersistnce } from '../../utils/authUtils';
import { useAuthStore } from '../../stores/authStore';

export const getQueryObj = (location) => {
    return new URLSearchParams(location.search);
};

const AuthCallback = ({ location }) => {
    const setAuthenticated = useAuthStore((state) => state.setAuthenticated);
    const setAccessToken = useAuthStore((state) => state.setAccessToken);
    const authenticated = useAuthStore((state) => state.authenticated);
    // const setUserDetails = useAuthStore(state => state.setUserDetails);

    const updateContext = (token) => {
        updateTokenForPersistnce(token);
        // setUserDetails(data);
        setAccessToken(token);
        setAuthenticated(true);
    };
    //   const getUser = async (token, redirect) => {
    //     try {
    //       updateTokenForPersistnce(token);
    //       const newUser = await userProfile();

    //       setAccessToken(token);
    //       // if (!newUser.country) {
    //       //   updateCountry('India')
    //       //     .then(userDetails => {
    //       //       if (userDetails.user) {
    //       //         setUserDetails(userDetails.user);
    //       //       }
    //       //     })
    //       //     .catch(ex => console.error(ex));
    //       //   // fetch(
    //       //   //   'http://ip-api.com/json/?fields=status,message,countryCode,country'
    //       //   // )
    //       //   //   .then(res => res.json())
    //       //   //   .then(data => {
    //       //   //     updateCountry(data.country)
    //       //   //       .then(userDetails => {
    //       //   //         if (userDetails.user) {
    //       //   //           setUserDetails(userDetails.user);
    //       //   //         }
    //       //   //       })
    //       //   //       .catch(ex => console.error(ex));
    //       //   //   })
    //       //   //   .catch(err => console.error(err, 'err'));
    //       // }
    //       setUserDetails(newUser);
    //       setAuthenticated(true);
    //       if (redirect) return history.push(redirect);
    //       history.push(`/policy${location.search}`);
    //     } catch (err) {
    //       console.error(err, 'login error');
    //       // const errorKey = err.response.data.key;
    //       history.push(`/${location.search}`);
    //     }
    //     return null;
    //   };
    const query = getQueryObj(location);
    const token = query.get('token');
    updateContext(token);

    if (authenticated) {
        return <Redirect to="/" />;
    }
    return <></>;
};

export default AuthCallback;
